import type { Payments } from './Payments';

export const base: Payments = {
    enabled: true,
    _description: 'Enable Payment Orders page',
    handleLocalErrors: {
        enabled: false,
        _description: 'Enables to handle local server errors, uses country specific translation',
    },
    useGroupSpecToRenderBadge: {
        enabled: false,
        _description: 'Show the badge based on payment and signInfo state',
    },
    useFocusPageSaveForLaterSnackbarNavigate: {
        enabled: false,
        _description:
            'Use snackbar notification and navigate to history page on focus page save for later click',
    },
    useFocusPageSaveForLaterSnackbarFormReset: {
        enabled: false,
        _description:
            'Use snackbar notification while reset payment form on focus page save for later click',
    },
    usePermittedAmountInStripeProductInfo: {
        enabled: false,
        _description: 'Use PermittedAmount in stripe for payments FocusPage and DetailPage',
    },
    showSnackbarOnResetPayment: {
        enabled: false,
        _description: 'Use snackbar notification while reset payment form',
    },
    isoAddressPaymentConfig: {
        enabled: false,
        _description: 'Use swift iso dynamic address form field structure mapping',
    },
    standingOrderAccountBasedList: {
        enabled: false,
        _description: 'Enabled SO list fetching for specific account with query params',
    },
    usePaymentsCalApiConfig: {
        enabled: false,
        _description: 'Enable payment form render via payments cal backend service',
    },
    bundleSigning: {
        enabled: true,
        _description: 'Enable bundle signing',
    },
    verificationOfPayee: {
        enabled: false,
        _description: 'Enable verification of payee',
    },
    verificationOfPayeeSto: {
        enabled: false,
        _description: 'Enable verification of payee for standing orders',
    },
    verificationOfPayeeBulk: {
        enabled: false,
        _description: 'Enable verification of payee for bulks',
    },
    receiverEditInModal: {
        enabled: false,
        _description: 'Enable editing receiver in modal after edit pencil click in card',
    },
    quickOwnTransfer: {
        enabled: false,
        _description: 'Show Quick Own Transfer navigation item',
    },
    editInstantPaymentLimitInForm: {
        enabled: false,
        _description: 'Allow changing the Instant Payment limit directly from the payment form',
    },
};
